var Conversation = require('conversation');
var OrderedBufferList = require('orderedbufferlist');


var ConversationList = OrderedBufferList.extend({
    model: Conversation
});


module.exports = ConversationList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/conversationlist.js
// module id = P0z8
// module chunks = 1